import { render, staticRenderFns } from "./addNewRole.vue?vue&type=template&id=4a0094c9"
import script from "./addNewRole.vue?vue&type=script&lang=js"
export * from "./addNewRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports